import React, { useState ,useEffect } from "react";
import { X } from "lucide-react";
import { sendQuotationEmail } from "../services/emailService";
import Swal from 'sweetalert2';

export default function RequestQuotationModal({
  isOpen,
  onClose,
  productName = "",
}) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    productName: productName,
  
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      productName: productName,
    }));
  }, [productName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await sendQuotationEmail(formData);
    setFormSubmitted(true);

    Swal.fire({
      icon: 'success',
      title: 'Request Sent!',
      text: 'Your quotation request has been sent successfully.',
      confirmButtonColor: '#73340E',
    });

    setTimeout(() => {
      setFormData({
        name: "",
        email: "",
        productName: productName,
      });
      setFormSubmitted(false);
    }, 3000);
  } catch (error) {
    console.error("Email send error:", error.message);
    Swal.fire({
      icon: 'error',
      title: 'Oops!',
      text: 'Something went wrong. Please try again later.',
      confirmButtonColor: '#73340E',
    });
  }
};

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-[#FBF1EB] rounded-lg w-full max-w-md relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#34302B] hover:text-[#73340E]"
          aria-label="Close modal"
        >
          <X size={24} />
        </button>

        <div className="p-6">
          <h2 className="text-3xl font-serif text-center text-[#34302B] mb-6">
            Request Quotation
          </h2>

          <form
            onSubmit={handleSubmit}
            className="border border-[#C19775] rounded-lg p-6"
          >
            <div className="mb-4">
              <label
                htmlFor="name"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                E-mail ID
              </label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="productName"
                className="block text-[#34302B] uppercase text-sm mb-2"
              >
                Product Name
              </label>
              <input
                type="text"
                id="productName"
                name="productName"
                value={formData.productName}
                onChange={handleChange}
                required
                className="w-full bg-gray-200 rounded p-2 text-[#34302B]"
              />
            </div>


            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-[#73340E] hover:bg-[#C09670] text-white px-8 py-2 rounded"
              >
                {formSubmitted ? "Request Sent!" : "Submit Request"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
